import { render, staticRenderFns } from "./stockType.vue?vue&type=template&id=6858dc72&scoped=true&"
import script from "./stockType.vue?vue&type=script&lang=js&"
export * from "./stockType.vue?vue&type=script&lang=js&"
import style0 from "./stockType.vue?vue&type=style&index=0&id=6858dc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858dc72",
  null
  
)

export default component.exports